// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: '67873980-eb57-447d-a6c1-a00cfa170fbe',
      type: 'Container',
      name: 'root',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        dynamicValues: {
          y: 'height * -0.5'
        }
      }
    },
    {
      id: '123a47a1-bd32-446e-b743-a79e161dbfec',
      type: 'Sprite',
      name: 'background',
      className: 'dynamicProps_SPL',
      x: 0,
      y: -10,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 12.1875,
        y: 20
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'square_64',
      parent: '67873980-eb57-447d-a6c1-a00cfa170fbe',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1'
        }
      }
    },
    {
      id: 'c19c0acb-4c05-4554-8075-515fe62d6db8',
      type: 'Container',
      name: 'popup',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 640,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '67873980-eb57-447d-a6c1-a00cfa170fbe',
      data: {
        dynamicValues: {
          y: 'height * 0.5'
        }
      }
    },
    {
      id: 'c93ce835-4dea-419d-a43b-792698e1a14c',
      type: 'Container',
      name: 'adCountdownSlot',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 70,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '67873980-eb57-447d-a6c1-a00cfa170fbe',
      data: {
        dynamicValues: {
          x: 'width * -0.5 + 20'
        }
      }
    },
    {
      id: 'e8b69740-c2fc-4cfd-a1eb-76f2009292d6',
      type: 'Sprite',
      name: 'floor',
      className: '',
      x: 0,
      y: 370,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.5,
        y: 1.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Special_Offer_Curtains_Floor',
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8'
    },
    {
      id: '0832e442-6ad2-4300-a9b9-ca0696cb8dba',
      type: 'Sprite',
      name: 'lights',
      className: '',
      x: 0,
      y: -650,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Special_Offer_Curtains_Lights',
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8'
    },
    {
      id: '1504cd57-ae8c-435f-82a5-c967a00cf875',
      type: 'Sprite',
      name: 'glow',
      className: '',
      x: 0,
      y: 44,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 0.8,
      visible: true,
      tint: 16764191,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Circle_Glow',
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8'
    },
    {
      id: 'b8361d6f-3bb3-4b9c-9eb6-64fd7801fe38',
      type: 'Container',
      name: 'particles',
      className: '',
      x: 0,
      y: -275,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8'
    },
    {
      id: '529b7efe-de42-4069-927b-d38cbc756756',
      type: 'Sprite',
      name: 'curtainLeft',
      className: '',
      x: -250,
      y: -70,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Special_Offer_Curtains_Alone',
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8'
    },
    {
      id: '07e259a0-3394-4a46-be4f-04383e7a8729',
      type: 'Sprite',
      name: 'curtainRight',
      className: '',
      x: 250,
      y: -70,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Special_Offer_Curtains_Alone',
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8'
    },
    {
      id: '631943dd-916f-4baf-9469-972917817769',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -441,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Purple_Ribbon',
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8'
    },
    {
      id: '22f2acf6-228b-48fa-a1e9-02d2dcbbeffe',
      type: 'Text',
      name: 'titleText',
      className: '',
      x: 8,
      y: -479,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Shuffle Up!',
      localize: true,
      maxWidth: 430,
      maxHeight: 100,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x5d058a',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8',
      data: {
        translations: {
          'Spin Frenzy': {
            en_US: 'Spin Frenzy',
            it_IT: 'Frenesia di rotazione',
            fr_FR: 'Frénésie de rotation',
            de_DE: 'Drehrausch',
            es_ES: 'Frenesí giratorio',
            pt_PT: 'Frenesi giratório',
            pl_PL: 'Wir obrotów',
            nl_NL: 'Draaiwaanzin',
            ko_KR: '회전 광란',
            ja_JP: 'スピン・フレンジー'
          },
          'Shuffle Up!': {
            en_US: 'Shuffle Up!',
            it_IT: 'Mescola!',
            fr_FR: 'Mélange !',
            de_DE: 'Mischen!',
            es_ES: '¡Baraja!',
            pt_PT: 'Baralha!',
            pl_PL: 'Przetasuj!',
            nl_NL: 'Schud!',
            ko_KR: '섞어!',
            ja_JP: 'シャッフル！'
          },
          'Hammer Time': {
            en_US: 'Hammer Time',
            it_IT: 'Ora del martello',
            fr_FR: 'C\'est l\'heure du marteau',
            de_DE: 'Hammerzeit',
            es_ES: 'Hora del martillo',
            pt_PT: 'Hora do martelo',
            pl_PL: 'Czas na młot',
            nl_NL: 'Hamertijd',
            ko_KR: '해머 타임',
            ja_JP: 'ハンマータイム'
          },
          Lifeline: {
            en_US: 'Lifeline',
            it_IT: 'Ancora di salvezza',
            fr_FR: 'Bouée de sauvetage',
            de_DE: 'Rettungsleine',
            es_ES: 'Salvavidas',
            pt_PT: 'Linha de vida',
            pl_PL: 'Koło ratunkowe',
            nl_NL: 'Reddingslijn',
            ko_KR: '생명줄',
            ja_JP: 'ライフライン'
          }
        }
      },
      stateByName: {
        fallback_spin_ns: {
          text: 'Spin Frenzy'
        },
        fallback_hammer_ns: {
          text: 'Hammer Time'
        },
        fallback_hammer_1: {
          text: 'Hammer Time'
        },
        fallback_hammer_2: {
          text: 'Hammer Time'
        },
        fallback_hammer_3: {
          text: 'Hammer Time'
        },
        fallback_lifeline_1: {
          text: 'Lifeline'
        },
        fallback_lifeline_2: {
          text: 'Lifeline'
        },
        fallback_lifeline_3: {
          text: 'Lifeline'
        }
      }
    },
    {
      id: '972e9549-bb4b-44bb-acee-7549d8cebf65',
      type: 'Text',
      name: 'descriptionText',
      className: '',
      x: 0,
      y: -360,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Infinite Lives, Coins, and Free Spins of the Lucky Wheel!',
      localize: true,
      maxWidth: 598,
      maxHeight: 100,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 550,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 6,
        dropShadowColor: '#520279',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8',
      data: {
        translations: {
          'Exclusive Offer! Grab 3 Shuffle Boosters!': {
            en_US: 'Exclusive Offer! Grab 3 Shuffle Boosters!',
            it_IT: 'Offerta esclusiva! Ottieni 3 Booster Shuffle!',
            fr_FR: 'Offre exclusive ! Obtenez 3 Boosters Shuffle !',
            de_DE: 'Exklusives Angebot! Hol dir 3 Shuffle-Booster!',
            es_ES: '¡Oferta exclusiva! ¡Consigue 3 potenciadores Shuffle!',
            pt_PT: 'Oferta exclusiva! Pegue 3 Boosters Shuffle!',
            pl_PL: 'Oferta ekskluzywna! Zdobądź 3 boostery Shuffle!',
            nl_NL: 'Exclusieve aanbieding! Pak 3 Shuffle-boosters!',
            ko_KR: '독점 혜택! 셔플 부스터 3개를 획득하세요!',
            ja_JP: '限定オファー！シャッフルブースター3個をゲット！'
          },
          'Exclusive Offer! 10 Free Spins on the Lucky Wheel!': {
            en_US: 'Exclusive Offer! 10 Free Spins on the Lucky Wheel!',
            it_IT: 'Offerta esclusiva! 10 giri gratis sulla Ruota della Fortuna!',
            fr_FR: 'Offre exclusive ! 10 tours gratuits sur la Roue de la Chance !',
            de_DE: 'Exklusives Angebot! 10 Freispiele am Glücksrad!',
            es_ES: '¡Oferta exclusiva! ¡10 tiradas gratis en la Ruleta de la Suerte!',
            pt_PT: 'Oferta exclusiva! 10 giros grátis na Roda da Fortuna!',
            pl_PL: 'Oferta ekskluzywna! 10 darmowych spinów na Kole Fortuny!',
            nl_NL: 'Exclusieve aanbieding! 10 gratis spins op het Geluksrad!',
            ko_KR: '독점 혜택! 럭키 휠에서 무료 스핀 10회!',
            ja_JP: '限定オファー！ラッキーホイールで無料スピン10回！'
          },
          'Exclusive Offer! Boosters to Smash Through Your Next Level!': {
            en_US: 'Exclusive Offer! Boosters to Smash Through Your Next Level!',
            it_IT: 'Offerta esclusiva! Booster per superare il tuo prossimo livello!',
            fr_FR: 'Offre exclusive ! Des boosters pour franchir votre prochain niveau !',
            de_DE: 'Exklusives Angebot! Booster, um dein nächstes Level zu meistern!',
            es_ES: '¡Oferta exclusiva! ¡Potenciadores para arrasar en tu próximo nivel!',
            pt_PT: 'Oferta exclusiva! Boosters para arrasar no seu próximo nível!',
            pl_PL: 'Oferta ekskluzywna! Boostery, które pomogą Ci przejść następny poziom!',
            nl_NL: 'Exclusieve aanbieding! Boosters om je volgende level te verpletteren!',
            ko_KR: '독점 혜택! 다음 레벨을 돌파할 부스터!',
            ja_JP: '限定オファー！次のレベルを突破するためのブースター！'
          },
          'Hammer Boosters to Smash Through Your Next Level!': {
            en_US: 'Hammer Boosters to Smash Through Your Next Level!',
            it_IT: 'Booster Martello per superare il tuo prossimo livello!',
            fr_FR: 'Boosters Marteau pour franchir votre prochain niveau !',
            de_DE: 'Hammer-Booster, um dein nächstes Level zu meistern!',
            es_ES: '¡Potenciadores Martillo para arrasar en tu próximo nivel!',
            pt_PT: 'Boosters Martelo para arrasar no seu próximo nível!',
            pl_PL: 'Boostery Młot, które pomogą Ci przejść następny poziom!',
            nl_NL: 'Hamer-boosters om je volgende level te verpletteren!',
            ko_KR: '해머 부스터로 다음 레벨을 돌파하세요!',
            ja_JP: 'ハンマーブースターで次のレベルを突破しよう！'
          },
          'Grab 3 Shuffle Boosters and a mountain of Coins!': {
            en_US: 'Grab 3 Shuffle Boosters and a mountain of Coins!',
            it_IT: 'Ottieni 3 Booster Shuffle e una montagna di monete!',
            fr_FR: 'Obtenez 3 Boosters Shuffle et une montagne de pièces !',
            de_DE: 'Hol dir 3 Shuffle-Booster und einen Berg Münzen!',
            es_ES: '¡Consigue 3 potenciadores Shuffle y una montaña de monedas!',
            pt_PT: 'Pegue 3 Boosters Shuffle e uma montanha de moedas!',
            pl_PL: 'Zdobądź 3 boostery Shuffle i górę monet!',
            nl_NL: 'Pak 3 Shuffle-boosters en een berg munten!',
            ko_KR: '셔플 부스터 3개와 산더미 같은 코인을 획득하세요!',
            ja_JP: 'シャッフルブースター3個と山のようなコインをゲット！'
          },
          'Grab 4 Shuffle Boosters and a mountain of Coins!': {
            en_US: 'Grab 4 Shuffle Boosters and a mountain of Coins!',
            it_IT: 'Ottieni 4 Booster Shuffle e una montagna di monete!',
            fr_FR: 'Obtenez 4 Boosters Shuffle et une montagne de pièces !',
            de_DE: 'Hol dir 4 Shuffle-Booster und einen Berg Münzen!',
            es_ES: '¡Consigue 4 potenciadores Shuffle y una montaña de monedas!',
            pt_PT: 'Pegue 4 Boosters Shuffle e uma montanha de moedas!',
            pl_PL: 'Zdobądź 4 boostery Shuffle i górę monet!',
            nl_NL: 'Pak 4 Shuffle-boosters en een berg munten!',
            ko_KR: '셔플 부스터 4개와 산더미 같은 코인을 획득하세요!',
            ja_JP: 'シャッフルブースター4個と山のようなコインをゲット！'
          },
          'Grab 6 Shuffle Boosters and a mountain of Coins!': {
            en_US: 'Grab 6 Shuffle Boosters and a mountain of Coins!',
            it_IT: 'Ottieni 6 Booster Shuffle e una montagna di monete!',
            fr_FR: 'Obtenez 6 Boosters Shuffle et une montagne de pièces !',
            de_DE: 'Hol dir 6 Shuffle-Booster und einen Berg Münzen!',
            es_ES: '¡Consigue 6 potenciadores Shuffle y una montaña de monedas!',
            pt_PT: 'Pegue 6 Boosters Shuffle e uma montanha de moedas!',
            pl_PL: 'Zdobądź 6 boosterów Shuffle i górę monet!',
            nl_NL: 'Pak 6 Shuffle-boosters en een berg munten!',
            ko_KR: '셔플 부스터 6개와 산더미 같은 코인을 획득하세요!',
            ja_JP: 'シャッフルブースター6個と山のようなコインをゲット！'
          },
          'Infinite Lives, Coins, and Free Spins of the Lucky Wheel!': {
            en_US: 'Infinite Lives, Coins, and Free Spins of the Lucky Wheel!',
            it_IT: 'Vite infinite, monete e giri gratis alla Ruota della Fortuna!',
            fr_FR: 'Vies infinies, pièces et tours gratuits à la Roue de la Chance !',
            de_DE: 'Unendliche Leben, Münzen und Freispiele am Glücksrad!',
            es_ES: '¡Vidas infinitas, monedas y tiradas gratis en la Ruleta de la Suerte!',
            pt_PT: 'Vidas infinitas, moedas e giros grátis na Roda da Fortuna!',
            pl_PL: 'Nieskończone życia, monety i darmowe spiny na Kole Fortuny!',
            nl_NL: 'Oneindige levens, munten en gratis spins op het Geluksrad!',
            ko_KR: '무한한 생명, 코인, 그리고 럭키 휠 무료 스핀!',
            ja_JP: '無限ライフ、コイン、そしてラッキーホイールの無料スピン！'
          }
        }
      },
      stateByName: {
        fallback_shuffle_ns: {
          text: 'Exclusive Offer! Grab 3 Shuffle Boosters!'
        },
        fallback_shuffle_1: {
          text: 'Grab 3 Shuffle Boosters and a mountain of Coins!'
        },
        fallback_shuffle_2: {
          text: 'Grab 4 Shuffle Boosters and a mountain of Coins!'
        },
        fallback_shuffle_3: {
          text: 'Grab 6 Shuffle Boosters and a mountain of Coins!'
        },
        fallback_spin_ns: {
          text: 'Exclusive Offer! 10 Free Spins on the Lucky Wheel!'
        },
        fallback_hammer_ns: {
          text: 'Exclusive Offer! Boosters to Smash Through Your Next Level!'
        },
        fallback_hammer_1: {
          text: 'Hammer Boosters to Smash Through Your Next Level!'
        },
        fallback_hammer_2: {
          text: 'Hammer Boosters to Smash Through Your Next Level!'
        },
        fallback_hammer_3: {
          text: 'Hammer Boosters to Smash Through Your Next Level!'
        },
        fallback_lifeline_1: {
          text: 'Infinite Lives, Coins, and Free Spins of the Lucky Wheel!'
        },
        fallback_lifeline_2: {
          text: 'Infinite Lives, Coins, and Free Spins of the Lucky Wheel!'
        },
        fallback_lifeline_3: {
          text: 'Infinite Lives, Coins, and Free Spins of the Lucky Wheel!'
        },
        purchased: {
          text: 'Infinite Lives, Coins, and Free Spins of the Lucky Wheel!'
        }
      }
    },
    {
      id: 'ba2f93ea-a744-4212-8b14-49f5b5f7dcf4',
      type: 'Container',
      name: 'badgeContainer',
      className: '',
      x: 275,
      y: -190,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8'
    },
    {
      id: 'c2ef3b7f-2b9a-4616-863a-1d38470e8c43',
      type: 'Container',
      name: 'rewardSlot1',
      className: '',
      x: -110,
      y: 40,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8'
    },
    {
      id: '55c0edea-97eb-4372-b12b-1e2005067f4d',
      type: 'Container',
      name: 'coinPile',
      className: '',
      x: 11,
      y: -97,
      scale: {
        x: 0.8,
        y: 0.8
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8'
    },
    {
      id: 'e61a2ce3-1f6f-4453-9b4b-735ef9087a19',
      type: 'Container',
      name: 'buyButton',
      className: '',
      x: 0,
      y: 455,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8'
    },
    {
      id: '323843df-ce4e-484f-b1f6-057d33e2102e',
      type: 'Container',
      name: 'closeButton',
      className: '',
      x: 323,
      y: -583,
      scale: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'c19c0acb-4c05-4554-8075-515fe62d6db8'
    },
    {
      id: '8a624b41-fe0d-4f82-9290-82f413b62af2',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Value_Badge_Blue',
      parent: 'ba2f93ea-a744-4212-8b14-49f5b5f7dcf4'
    },
    {
      id: '76d7a420-6ff3-4691-ba4f-e81b53bdc1f9',
      type: 'Text',
      name: 'badgeTextBig',
      className: '',
      x: 3,
      y: -15,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 15,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '400%',
      localize: false,
      maxWidth: 126,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x153e82',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'ba2f93ea-a744-4212-8b14-49f5b5f7dcf4',
      stateByName: {
        fallback_shuffle_ns: {
          text: '300%'
        },
        fallback_shuffle_1: {
          text: '160%'
        },
        fallback_shuffle_2: {
          text: '150%'
        },
        fallback_shuffle_3: {
          text: '140%'
        },
        fallback_spin_ns: {
          text: '240%'
        },
        fallback_hammer_ns: {
          text: '270%'
        },
        fallback_hammer_1: {
          text: '180%'
        },
        fallback_hammer_2: {
          text: '160%'
        },
        fallback_hammer_3: {
          text: '130%'
        },
        fallback_lifeline_1: {
          text: '200%'
        },
        fallback_lifeline_2: {
          text: '190%'
        },
        fallback_lifeline_3: {
          text: '180%'
        }
      }
    },
    {
      id: '7bbf176c-a5af-4033-ab76-24030c9e4a07',
      type: 'Text',
      name: 'badgeTextSmall',
      className: '',
      x: -8,
      y: 21,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 15,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'EXTRA',
      localize: false,
      maxWidth: 100,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x153e82',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'ba2f93ea-a744-4212-8b14-49f5b5f7dcf4'
    },
    {
      id: '0cfe3898-f8b9-4cf9-8004-94e240da05b8',
      type: 'Container',
      name: 'coinsContainer',
      className: '',
      x: 0,
      y: 80,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '55c0edea-97eb-4372-b12b-1e2005067f4d',
      stateByName: {
        fallback_shuffle_ns: {
          visible: false
        },
        fallback_shuffle_1: {
          x: -115
        },
        fallback_shuffle_2: {
          x: -115
        },
        fallback_shuffle_3: {
          x: -115
        },
        fallback_spin_ns: {
          visible: false
        },
        fallback_hammer_ns: {
          visible: false
        },
        fallback_hammer_1: {
          visible: false
        },
        fallback_hammer_2: {
          visible: false
        },
        fallback_hammer_3: {
          visible: false
        }
      }
    },
    {
      id: '10456323-609d-496c-bb84-eba71f5e21b6',
      type: 'Container',
      name: 'hammerContainer',
      className: '',
      x: -302,
      y: 172,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '55c0edea-97eb-4372-b12b-1e2005067f4d',
      stateByName: {
        fallback_shuffle_ns: {
          visible: false
        },
        fallback_shuffle_1: {
          visible: false
        },
        fallback_shuffle_2: {
          visible: false
        },
        fallback_shuffle_3: {
          visible: false
        },
        fallback_spin_ns: {
          visible: false
        },
        fallback_hammer_ns: {
          x: 0
        },
        fallback_hammer_1: {
          x: 0
        },
        fallback_hammer_2: {
          x: 0
        },
        fallback_hammer_3: {
          x: 0
        },
        fallback_lifeline_1: {
          visible: false
        },
        fallback_lifeline_2: {
          visible: false
        },
        fallback_lifeline_3: {
          visible: false
        }
      }
    },
    {
      id: 'b0492952-8344-480d-bc44-40e107a6970f',
      type: 'Container',
      name: 'spinContainer',
      className: '',
      x: -303,
      y: 172,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '55c0edea-97eb-4372-b12b-1e2005067f4d',
      stateByName: {
        fallback_shuffle_ns: {
          visible: false
        },
        fallback_shuffle_1: {
          visible: false
        },
        fallback_shuffle_2: {
          visible: false
        },
        fallback_shuffle_3: {
          visible: false
        },
        fallback_spin_ns: {
          x: 0
        },
        fallback_hammer_ns: {
          visible: false
        },
        fallback_hammer_1: {
          visible: false
        },
        fallback_hammer_2: {
          visible: false
        },
        fallback_hammer_3: {
          visible: false
        }
      }
    },
    {
      id: 'add9c648-6c01-4451-a410-4a381b48ef3e',
      type: 'Container',
      name: 'heartContainer',
      className: '',
      x: 303,
      y: 182,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '55c0edea-97eb-4372-b12b-1e2005067f4d',
      stateByName: {
        fallback_shuffle_ns: {
          visible: false
        },
        fallback_shuffle_1: {
          visible: false
        },
        fallback_shuffle_2: {
          visible: false
        },
        fallback_shuffle_3: {
          visible: false
        },
        fallback_spin_ns: {
          visible: false
        },
        fallback_hammer_ns: {
          visible: false
        },
        fallback_hammer_1: {
          visible: false
        },
        fallback_hammer_2: {
          visible: false
        },
        fallback_hammer_3: {
          visible: false
        }
      }
    },
    {
      id: '3cc803e9-3f6b-4cfd-b5ac-c8262786657e',
      type: 'Container',
      name: 'shuffleContainer',
      className: '',
      x: 303,
      y: 182,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '55c0edea-97eb-4372-b12b-1e2005067f4d',
      stateByName: {
        fallback_shuffle_ns: {
          x: 0
        },
        fallback_shuffle_1: {
          x: 162
        },
        fallback_shuffle_2: {
          x: 162
        },
        fallback_shuffle_3: {
          x: 162
        },
        fallback_spin_ns: {
          visible: false
        },
        fallback_hammer_ns: {
          visible: false
        },
        fallback_hammer_1: {
          visible: false
        },
        fallback_hammer_2: {
          visible: false
        },
        fallback_hammer_3: {
          visible: false
        },
        fallback_lifeline_1: {
          visible: false
        },
        fallback_lifeline_2: {
          visible: false
        },
        fallback_lifeline_3: {
          visible: false
        }
      }
    },
    {
      id: 'fc7c791e-391d-4cdb-ae6a-6779de7f616a',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'e61a2ce3-1f6f-4453-9b4b-735ef9087a19',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      },
      interactiveChildren: false
    },
    {
      id: '1667d966-259c-4bf0-93bd-5323ea8b1e8e',
      type: 'Text',
      name: 'priceLabel',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<price>',
      localize: false,
      maxWidth: 340,
      maxHeight: 100,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x006100',
        strokeThickness: 7,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'e61a2ce3-1f6f-4453-9b4b-735ef9087a19',
      data: {
        translations: {
          Purchased: {
            en_US: 'Purchased',
            it_IT: 'Acquistato',
            fr_FR: 'Acheté',
            de_DE: 'Gekauft',
            es_ES: 'Comprado',
            pt_PT: 'Comprado',
            pl_PL: 'Kupiono',
            nl_NL: 'Gekocht',
            ko_KR: '구매함',
            ja_JP: '購入済み'
          }
        }
      },
      stateByName: {
        purchased: {
          text: 'Purchased',
          localize: true
        }
      }
    },
    {
      id: '90813cc8-287a-46eb-ad48-17046008a9ba',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Shop_Close_Button',
      parent: '323843df-ce4e-484f-b1f6-057d33e2102e'
    },
    {
      id: '643b6eab-b0f1-4833-916f-7ed4873fb2e2',
      type: 'Sprite',
      name: '',
      className: '',
      x: -60,
      y: 88,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16771775,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: '0cfe3898-f8b9-4cf9-8004-94e240da05b8'
    },
    {
      id: 'd08fd061-d470-4a83-9291-ea7811fbbdee',
      type: 'Sprite',
      name: '',
      className: '',
      x: -28,
      y: 137,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16759862,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: '0cfe3898-f8b9-4cf9-8004-94e240da05b8'
    },
    {
      id: 'bfe04bf6-5213-4f18-a798-9613ff1137b7',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16771775,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: '0cfe3898-f8b9-4cf9-8004-94e240da05b8'
    },
    {
      id: '47b38d88-d727-4c2f-a578-40bf6531219e',
      type: 'Sprite',
      name: '',
      className: '',
      x: 18,
      y: 62,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16771775,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: '0cfe3898-f8b9-4cf9-8004-94e240da05b8'
    },
    {
      id: '2124a66d-15b3-4837-83ae-718d30a55e8c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 77,
      y: 105,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: '0cfe3898-f8b9-4cf9-8004-94e240da05b8'
    },
    {
      id: 'e5a179be-4462-4050-bd06-0af2150aaa3b',
      type: 'Sprite',
      name: '',
      className: '',
      x: -90,
      y: 154,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: '0cfe3898-f8b9-4cf9-8004-94e240da05b8'
    },
    {
      id: '88e64ab5-31f4-4ee2-9712-a0e5caec3103',
      type: 'Sprite',
      name: '',
      className: '',
      x: 98,
      y: 166,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: '0cfe3898-f8b9-4cf9-8004-94e240da05b8'
    },
    {
      id: 'f93965ae-b3cf-422f-af27-a53791c492a0',
      type: 'Sprite',
      name: 'sparkle1',
      className: '',
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Sparkle',
      parent: '0cfe3898-f8b9-4cf9-8004-94e240da05b8'
    },
    {
      id: '27f725e3-38a0-46e4-87b0-dc5b16c62f46',
      type: 'Sprite',
      name: 'sparkle2',
      className: '',
      x: -68,
      y: 106,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Sparkle',
      parent: '0cfe3898-f8b9-4cf9-8004-94e240da05b8'
    },
    {
      id: 'd4a14be5-8d99-45b0-9b72-2fbfcdacfe62',
      type: 'Sprite',
      name: 'sparkle3',
      className: '',
      x: 72,
      y: 165,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Sparkle',
      parent: '0cfe3898-f8b9-4cf9-8004-94e240da05b8'
    },
    {
      id: '1aff94c2-3768-4c6b-90bd-01e483bde5fb',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 247,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x2,000',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0cfe3898-f8b9-4cf9-8004-94e240da05b8',
      stateByName: {
        fallback_shuffle_1: {
          text: 'x1,000'
        },
        fallback_shuffle_3: {
          text: 'x3,000'
        },
        fallback_lifeline_1: {
          text: 'x1,000'
        },
        fallback_lifeline_3: {
          text: 'x3,000'
        }
      }
    },
    {
      id: 'd1436f9e-e423-48df-b1c5-ccb401d8a8b1',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster',
      parent: '10456323-609d-496c-bb84-eba71f5e21b6',
      stateByName: {
        fallback_hammer_1: {
          scale: {
            y: 0.9,
            x: 0.9
          }
        },
        fallback_hammer_2: {
          scale: {
            x: 0.9,
            y: 0.9
          }
        },
        fallback_hammer_3: {
          scale: {
            x: 0.9,
            y: 0.9
          }
        },
        purchased: {
          scale: {
            x: 0.8,
            y: 0.8
          }
        },
        fallback_hammer_ns: {
          scale: {
            y: 0.9,
            x: 0.9
          }
        }
      }
    },
    {
      id: '7bdd30a1-341f-46a3-8c46-446e61b3a75c',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 155,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '10456323-609d-496c-bb84-eba71f5e21b6',
      stateByName: {
        fallback_hammer_ns: {
          text: 'x2'
        },
        fallback_hammer_1: {
          text: 'x2'
        },
        fallback_hammer_3: {
          text: 'x4'
        }
      }
    },
    {
      id: '4e73777c-40f3-4614-8896-8fdc81090539',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.5,
        y: 1.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Item_Icon',
      parent: 'b0492952-8344-480d-bc44-40e107a6970f',
      stateByName: {
        fallback_lifeline_1: {
          scale: {
            x: 1.7,
            y: 1.7
          }
        },
        fallback_lifeline_2: {
          scale: {
            x: 1.7,
            y: 1.7
          }
        },
        fallback_lifeline_3: {
          scale: {
            x: 1.7,
            y: 1.7
          }
        },
        purchased: {
          scale: {
            x: 1.7,
            y: 1.7
          }
        },
        fallback_spin_ns: {
          scale: {
            y: 1.8,
            x: 1.8
          }
        }
      }
    },
    {
      id: 'cb81ad63-78cc-4582-a87e-b3c642d9d41f',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 155,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'b0492952-8344-480d-bc44-40e107a6970f',
      stateByName: {
        fallback_spin_ns: {
          text: 'x10'
        },
        fallback_lifeline_1: {
          text: 'x2'
        },
        fallback_lifeline_2: {
          text: 'x4'
        },
        fallback_lifeline_3: {
          text: 'x6'
        }
      }
    },
    {
      id: 'e2a9fd49-4d58-4e70-8a23-a055267ad8c5',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Big_New',
      parent: 'add9c648-6c01-4451-a410-4a381b48ef3e',
      stateByName: {
        fallback_lifeline_1: {
          scale: {
            x: 0.9,
            y: 0.9
          }
        },
        fallback_lifeline_2: {
          scale: {
            x: 0.9,
            y: 0.9
          }
        },
        fallback_lifeline_3: {
          scale: {
            x: 0.9,
            y: 0.9
          }
        },
        purchased: {
          scale: {
            x: 0.9,
            y: 0.9
          }
        }
      }
    },
    {
      id: 'bf2c0c18-1741-454e-a5ce-d7f8a16c23cb',
      type: 'Sprite',
      name: '',
      className: '',
      x: 1,
      y: -11,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Infinity',
      parent: 'add9c648-6c01-4451-a410-4a381b48ef3e'
    },
    {
      id: '58e1e84a-bcdf-4e37-8142-5b7e06e805eb',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 145,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<amount>h',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'add9c648-6c01-4451-a410-4a381b48ef3e',
      data: {
        translations: {
          '1.5h': {
            en_US: '1.5h',
            it_IT: '1.5h',
            fr_FR: '1.5h',
            de_DE: '1.5Std',
            es_ES: '1.5h',
            pt_PT: '1.5h',
            pl_PL: '1.5godz',
            nl_NL: '1.5u',
            ko_KR: '1.5시간',
            ja_JP: '1.5時間'
          },
          '2h': {
            en_US: '2h',
            it_IT: '2h',
            fr_FR: '2h',
            de_DE: '2Std',
            es_ES: '2h',
            pt_PT: '2h',
            pl_PL: '2godz',
            nl_NL: '2u',
            ko_KR: '2시간',
            ja_JP: '2時間'
          },
          '3h': {
            en_US: '3h',
            it_IT: '3h',
            fr_FR: '3h',
            de_DE: '3Std',
            es_ES: '3h',
            pt_PT: '3h',
            pl_PL: '3godz',
            nl_NL: '3u',
            ko_KR: '3시간',
            ja_JP: '3時間'
          }
        }
      },
      stateByName: {
        fallback_lifeline_1: {
          text: '1.5h'
        },
        fallback_lifeline_3: {
          text: '3h'
        },
        fallback_lifeline_2: {
          text: '2h'
        }
      }
    },
    {
      id: '22f6f73c-452d-418d-83a6-ecb133242c5b',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Swap_Booster',
      parent: '3cc803e9-3f6b-4cfd-b5ac-c8262786657e',
      stateByName: {
        purchased: {
          scale: {
            x: 0.8,
            y: 0.8
          }
        },
        fallback_shuffle_3: {
          scale: {
            x: 0.8,
            y: 0.8
          }
        },
        fallback_shuffle_2: {
          scale: {
            x: 0.8,
            y: 0.8
          }
        },
        fallback_shuffle_1: {
          scale: {
            x: 0.8,
            y: 0.8
          }
        },
        fallback_shuffle_ns: {
          scale: {
            x: 0.9,
            y: 0.9
          }
        }
      }
    },
    {
      id: 'c9308701-be63-4030-accf-4da9b263ea82',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 145,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3cc803e9-3f6b-4cfd-b5ac-c8262786657e',
      stateByName: {
        fallback_shuffle_ns: {
          text: 'x3'
        },
        fallback_shuffle_1: {
          text: 'x3'
        },
        fallback_shuffle_2: {
          text: 'x4'
        },
        fallback_shuffle_3: {
          text: 'x6'
        },
        fallback_lifeline_2: {
          text: '2h'
        },
        fallback_lifeline_3: {
          text: '<amount>h'
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 1280,
  version: '4.0.1',
  stateNames: [
    'fallback_shuffle_ns',
    'fallback_shuffle_1',
    'fallback_shuffle_2',
    'fallback_shuffle_3',
    'fallback_spin_ns',
    'fallback_hammer_ns',
    'fallback_hammer_1',
    'fallback_hammer_2',
    'fallback_hammer_3',
    'fallback_lifeline_1',
    'fallback_lifeline_2',
    'fallback_lifeline_3',
    'purchased'
  ],
  animations: [
    {
      id: '2fbe8b8a-c519-4b95-8fb0-277a9803f6de',
      name: 'showCloseButton',
      playingSpeed: 1,
      totalDuration: 200,
      blocks: [
        {
          id: '3492b3e3-6ee1-48c1-98ff-cb5d047f83c6',
          type: 'Tween',
          name: 'TWEEN_root',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 0,
          sourceName: 'closeButton',
          easing: 'CubicOut',
          disabled: false
        }
      ]
    },
    {
      id: '7320039f-f10e-445f-8342-58cb5d9f8c93',
      name: 'Idle',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: '00ef1e7b-ad41-4292-ae0c-dc154bff1a42',
          type: 'Setter',
          name: 'FXPART_Curtain_Particles',
          track: 1,
          target: {},
          startAt: 0,
          sourceName: 'particles',
          disabled: false
        },
        {
          id: 'f4bc6599-4f52-4dd2-936b-02676462b7f5',
          type: 'Tween',
          name: 'buyButtonScale',
          duration: 1000,
          track: 3,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 0,
          sourceName: 'buyButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '84ac7628-5fb3-4a0b-8507-43c1ea2e5ba4',
          type: 'Tween',
          name: 'badgeRotation',
          duration: 1000,
          track: 5,
          target: {
            angle: -5
          },
          startAt: 0,
          sourceName: 'badgeContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f80c77a3-d5d3-49a4-9768-dd3bd694e05c',
          type: 'Tween',
          name: 'badgeRotation_copy',
          duration: 1000,
          track: 5,
          target: {
            angle: 0
          },
          startAt: 1000,
          sourceName: 'badgeContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '9c7f8aa3-5992-4a4a-a145-499c30eb3e44',
          type: 'Tween',
          name: 'buyButtonScale_copy',
          duration: 1000,
          track: 3,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1000,
          sourceName: 'buyButton',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class SpecialOfferAdFallbackLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  background!: Sprite & { data: typeof raw['list'][1]['data'] };
  popup!: Container & { data: typeof raw['list'][2]['data'] };
  adCountdownSlot!: Container & { data: typeof raw['list'][3]['data'] };
  floor!: Sprite;
  lights!: Sprite;
  glow!: Sprite;
  particles!: Container;
  curtainLeft!: Sprite;
  curtainRight!: Sprite;
  titleText!: Text & { data: typeof raw['list'][11]['data'] };
  descriptionText!: Text & { data: typeof raw['list'][12]['data'] };
  badgeContainer!: Container;
  rewardSlot1!: Container;
  coinPile!: Container;
  buyButton!: Container;
  closeButton!: Container;
  badgeTextBig!: Text;
  badgeTextSmall!: Text;
  coinsContainer!: Container;
  hammerContainer!: Container;
  spinContainer!: Container;
  heartContainer!: Container;
  shuffleContainer!: Container;
  priceLabel!: Text & { data: typeof raw['list'][27]['data'] };
  sparkle1!: Sprite;
  sparkle2!: Sprite;
  sparkle3!: Sprite;
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][0]['data'] } | Sprite & { data: typeof raw['list'][1]['data'] } | Container & { data: typeof raw['list'][2]['data'] } | Container & { data: typeof raw['list'][3]['data'] })[];
  StateName!: 'fallback_shuffle_ns' | 'fallback_shuffle_1' | 'fallback_shuffle_2' | 'fallback_shuffle_3' | 'fallback_spin_ns' | 'fallback_hammer_ns' | 'fallback_hammer_1' | 'fallback_hammer_2' | 'fallback_hammer_3' | 'fallback_lifeline_1' | 'fallback_lifeline_2' | 'fallback_lifeline_3' | 'purchased';

  constructor() {
    populate(this, raw);
  }
}

export abstract class showCloseButton {
  Layout: {
    closeButton: object;
  };

  BlockTypeByName: {
    TWEEN_root: object;
  };

  flowData = raw.animations[0];
}

export abstract class Idle {
  Layout: {
    particles: object;
    buyButton: object;
    badgeContainer: object;
  };

  BlockTypeByName: {
    FXPART_Curtain_Particles: object;
    buyButtonScale: object;
    badgeRotation: object;
    badgeRotation_copy: object;
    buyButtonScale_copy: object;
  };

  flowData = raw.animations[1];
}
